const s = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;
export const Icon = {
  home: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
    </svg>
  ),
  inbox: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M3 13l3-8h12l3 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
      <path d="M3 13h5l1 3h6l1-3h5" />
    </svg>
  ),
  walls: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  sources: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
    </svg>
  ),
  discover: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
    </svg>
  ),
  rights: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  products: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M5 8h14l-1 12H6z" />
      <path d="M9 8a3 3 0 0 1 6 0" />
    </svg>
  ),
  seasons: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </svg>
  ),
  taste: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M12 20s-7-4.3-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.7-7 10-7 10z" />
    </svg>
  ),
  ai: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    </svg>
  ),
  insights: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <path d="M4 20h16M7 16v-5M12 16V7M17 16v-8" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...s}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1" />
    </svg>
  ),
  menu: (
    <svg viewBox="0 0 24 24" aria-hidden="true" width="22" height="22" {...s}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  ),
};
